module.exports = __webpack_public_path__ + "static/img/use02.ff3eef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/use02.png
// module id = BOK+
// module chunks = 10